import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '@environments/environment'
import { Observable } from 'rxjs'

export type ContactlessOptionsEntity = 'event' | 'form' | 'form-element'

export interface ContactlessOptionsData {
  id: number
  /** Confirmation button text. Returned on the form options payload, beside `options`. */
  editLabel?: string
  options: Record<string, unknown>
}

export interface ContactlessOptionsResponse {
  message: string
  data: ContactlessOptionsData
}

export interface ContactlessOptionsPatchPayload {
  set?: Record<string, unknown>
  unset?: string[]
}

@Injectable()
export class ContactlessOptionsService {
  private readonly _pathByEntity: Record<ContactlessOptionsEntity, string> = {
    event: 'events',
    form: 'forms',
    'form-element': 'form-elements'
  }

  constructor(private readonly _http: HttpClient) {}

  getOptions(entity: ContactlessOptionsEntity, id: number): Observable<ContactlessOptionsResponse> {
    return this._http.get<ContactlessOptionsResponse>(this._url(entity, id))
  }

  patchOptions(entity: ContactlessOptionsEntity, id: number, payload: ContactlessOptionsPatchPayload): Observable<ContactlessOptionsResponse> {
    return this._http.patch<ContactlessOptionsResponse>(this._url(entity, id), payload)
  }

  private _url(entity: ContactlessOptionsEntity, id: number): string {
    return `${environment.planningApi}admin/${this._pathByEntity[entity]}/${id}/options`
  }
}
